<template>
  <div class="index" v-if='showView'>
        <van-nav-bar
                :fixed='true'
                title="民生通讯电信5G入网"
            />
        <van-swipe class="index-swipe"  :autoplay="3000" :duration='100' indicator-color='#39A9ED'>
            <van-swipe-item v-for="img in SwipeImage" :key="img">
                <img :src="img" >
            </van-swipe-item>
        </van-swipe>
        <van-steps
            :active="currentStep - 1"
            active-icon="passed"
            active-color="#38f"
            >
            <van-step>卡校验</van-step>
            <van-step>套餐选择</van-step>
            <van-step>证件上传</van-step>
            <van-step>活体认证</van-step>
            <van-step>信息提交</van-step>
        </van-steps>
        <div v-if='currentStep == 1'>
            <van-search
                v-model="search.phonenum"
                placeholder="请输入手机号码"
                left-icon='phone-circle-o'
                shape="round"
                >
            </van-search>
            <van-search
                v-model="search.iccid"
                placeholder="请输入ICCID"
                left-icon='comment-circle-o'
                shape="round"
                @search="queryPackageList"
                >
            </van-search>
            
            <div class="submitInfo">
                <div class="submitInfo-btn">
                    <van-button type="primary" size="large" @click="queryPackageList()">下一步</van-button>
                </div>
            </div>
        </div>
        <div v-if="currentStep == 2 && packageList != null  && packageList.length > 0" class="packageChoice-pack">
            <div class="packageChoice-pack-list">
                <van-sidebar v-model="packageActiveKey">
                    <van-sidebar-item
                    style="color:#20A0FF;"
                    @click='packageChoiceClick'
                        v-for="(item,index) in packageList" 
                        :key="index"
                        :title="item.pName">
                    </van-sidebar-item>
                </van-sidebar>
            </div>
            <div class="packageChoice-pack-info">
                <van-panel title="套餐内容项">
                    <div style="padding:10px 0px;">{{packageChoiceDetail != null ?packageChoiceDetail.pDesc:''}}</div>
                </van-panel>
            </div>
            <div class="submitInfo">
                <div class="submitInfo-btn">
                    <van-button type="primary" size="large" @click="checkPayMoney()">下一步</van-button>
                </div>
            </div>
        </div>
        <div v-if='currentStep == 3'>
            <div class="picInfo">
                <van-panel title="证件照" desc="上传证件材料（身份证照片上的信息必须清晰可见）">
                    <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[0].imgPath' :resultImage.sync='picNameZ' :desc.sync='picOver[0].desc' :imageInfoObj.sync='imageZInfoObj' :isAnalyze.sync='isAnalyzeZ' :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
                    <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[1].imgPath' :resultImage.sync='picNameF' :desc.sync='picOver[1].desc' :imageInfoObj.sync='imageFInfoObj' :isAnalyze.sync='isAnalyzeF' :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath'/>
                </van-panel>
            </div>
            <div class="user">
                <van-cell-group>
                    <van-field
                        placeholder="请输入激活的号码"
                        label="开户号码"
                        left-icon="phone-circle-o"
                        v-model="userInfo.phonenum"
                        readonly
                    />
                    <van-field
                        placeholder="请输入ICCID"
                        label="ICCID"
                        left-icon="comment-circle-o"
                        v-model="userInfo.iccid"
                        readonly
                    />
                    <van-field
                        placeholder="请输入接收结果通知的号码"
                        label="联系号码"
                        left-icon="phone-o"
                        required
                        v-model="userInfo.contractPhone"
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="身份证号"
                        left-icon="idcard"
                        v-model="userInfo.psptId"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="姓名"
                        left-icon="user-circle-o"
                        v-model="userInfo.custName"
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="性别"
                        left-icon="contact"
                        v-model="userInfo.sex"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="民族"
                        left-icon="friends-o"
                        v-model="userInfo.nation"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="生日"
                        left-icon="debit-pay"
                        v-model="userInfo.birthday"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="证件地址"
                        left-icon="shrink"
                        v-model="userInfo.psptLocation"
                    />
                    <van-field
                        placeholder="上传证件照反面自动识别"
                        label="签发机关"
                        left-icon="records"
                        v-model="userInfo.penOrg"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照反面自动识别"
                        label="签发日期"
                        left-icon="todo-list-o"
                        v-model="userInfo.penStartTime"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照反面自动识别"
                        label="到期日期"
                        left-icon="todo-list-o"
                        v-model="userInfo.penEndTime"
                        readonly
                    />
                </van-cell-group>
            </div>
            <div class="submitInfo">
                <div class="submitInfo-checked">
                    <input type="checkbox" v-model="userInfo.readContract" />
                    <span @click="showContractFile" >我已阅读并同意《民生通讯入网协议》</span>
                </div>
                <div class="submitInfo-btn">
                    <van-button type="primary" size="large" @click="goVideo()">下一步</van-button>
                </div>
                <ContractInfo :showContract.sync='showContract' :popuTime.sync='popuTime' :userA.sync='userInfo.custName' :readContract.sync='userInfo.readContract' @showContractClick='showContractClick'></ContractInfo>
            </div>
        </div>
        <div v-if="currentStep == 4">
            <div class="sketch3">
                <div class="sketch3-img"><img src="../../assets/video/sketch.png" /></div>
                <p class="sketch3-text">正面平视手机、保证光线充足<br />请勿遮挡面部</p>
            </div>
            <div class="prompt">
                <div class="prompt-box">
                    <div class="prompt-box-text" v-for="item in items" :key="item.number">
                        <span class="prompt-box-text-number">{{item.number}}</span><span class="prompt-box-text-content">{{item.text}}</span>
                        <span class="prompt-box-text-border" v-if="item.border"></span>
                    </div>
                </div>
                <span class="prompt-next"
                    :class="{'prompt-next-disabled': nextDisabled}"
                    @click="startVideo()">开始</span>
            </div>
        </div>
        <div v-if='currentStep == 5' class='video'>
            <verifyCodeModal v-if="showVerifyCodeModal"
                @cancel="onDialogCancel"
                @videoResult="onDialogVideoResult"
                :videoFail.sync="videoFail"
                :videoFailText.sync="videoFailText"
                :orderCode.sync="userInfo.orderCode"
                :serialNumber.sync='userInfo.phonenum'
                :simcheck.sync='userInfo.simcheck'
                />
            <result v-if="showResult"
                @finish="submitData"
                @restart="onDialogAgain"
                :showResult.sync="showResult"
                :videoResultDetail="videoResultDetail"></result>
            <loading v-if="showLoading" :loadLabel.sync='loadLabel' ></loading>
            <popupAlert v-if="showPopup" :showPopupLable.sync='showPopupLable'
                :showPopup.sync="showPopup" />
        </div>
         <van-popup v-model="showPopupLoading" style="background-color:#4C4C4C;" :lazy-render=false :close-on-click-overlay=false >
                <van-loading size="24px" vertical>{{loadingText}}</van-loading>
        </van-popup>
        <van-dialog
            v-model="showPayInfoView"
            title="支付提示"
            style='height:70%;'
            show-cancel-button
            :close-on-popstate =true
            :close-on-click-overlay = true
            @confirm='goUserInfo()'
        >
            <div class="needPayInfo" v-if="needPayInfo">
                <van-cell-group>
                    <van-field  v-model="needPayInfo.phonenum" label="手机号" readonly />
                    <van-field  v-model="needPayInfo.pName" label="套餐包" readonly />
                    <van-field  v-model="needPayInfo.backMoney" label="返还金额" readonly />
                    <van-field  v-model="needPayInfo.backMonth" label="返还月份" readonly />
                    <van-field  v-model="needPayInfo.rechareMoney" label="开户预存" readonly />
                    <van-field  v-model="needPayInfo.payMoney" label="需付款" readonly />
                </van-cell-group>
                <div class="needPayInfo-warning">
                    <div class="needPayInfo-warning-title">友情提示:</div>
                    <div class="needPayInfo-warning-text">需付款金额 = 返还金额 * 返还月份 + 开户预存</div>
                </div>
            </div>
        </van-dialog>
  </div>
</template>

<script>
    import {setAesString} from "../../config/date";
    import zmOver from '@/assets/half_year_zm.jpg';
    import fmOver from '@/assets/half_year_bm.jpg';
    import tmOver from '@/assets/half_year_sc.jpg';
    import ContractInfo from '@/components/ContractInfo';
    import PictureCamera from '@/components/PictureCamera';
    import {formatTime,isWeiXin} from '../../common/functionUtil';
    import {dataURLtoBlob} from '../../common/functionUtil';
    import verifyCodeModal from '@/components/video/mobile/verifyCodeModal';
    import loading from '@/components/video/mobile/loading';
    import result from '@/components/video/mobile/result';
    import popupAlert from '@/components/video/mobile/popupAlert';
    import { Dialog } from 'vant';

export default {
  name: 'index',
  components: {
      ContractInfo,
      PictureCamera,
      verifyCodeModal,
      loading,
      result,
      popupAlert
  },
  data(){
        return{
            search:{
                phonenum:'',
                iccid:'',
                cl:''
            },
            showPopupLoading:false,
            showView:true,
            showPayInfoView:false,
            currentStep:1,//步骤
            //上传文件的url
            uploadImagePath:this.$api.uploadBossFileBaseUrl,
            //读取图片的url
            readImagePath:this.$api.readBossImagePath,
            packageChoiceDetail:null,
            packageList:[],
            packageActiveKey:0,//套餐选择的下标
            needPayInfo:{},
            // userInfo:{
            //     phonenum:'16262048450',
            //     iccid:'8986111944632119990',
            //     readContract:false,
            //     custName:'蔡甜甜',
            //     psptId:'13012319880921152X',
            //     sex:'女',
            //     nation:'汉',
            //     birthday:'1988-09-21',          
            //     psptLocation:'河北省石家庄市正定县南牛乡北永固村永胜街8号',
            //     penOrg:'正定县公安局',
            //     penStartTime:'2017-06-15',
            //     penEndTime:'2037-06-15',
            //     contractPhone:'17090335353',
            //     picNameZ:'201912/Z982dbbd6f5074c2e9a9161f5de399c86.jpg',
            //     picNameF:'201912/F7ab3984c1c7446ac8aae0cacc5038302.jpg',
            //     picNameT:'201912/V723b5d49c4a54d7b860c3ff85a76efa7.jpg',
            //     orderCode:'',
            //     simcheck:'1'
            // },
            userInfo:{
                phonenum:'',
                iccid:'',
                readContract:false,
                custName:'',
                psptId:'',
                sex:'',
                nation:'',
                birthday:'',          
                psptLocation:'',
                penOrg:'',
                penStartTime:'',
                penEndTime:'',
                contractPhone:'',
                picNameZ:null,
                picNameF:null,
                picNameT:null,
                orderCode:'',
                simcheck:'1'
            },
            picNameZ:null,
            picNameF:null,
            picNameT:null,
            picWidth:'280px',
            picHeight:'250px',
            picOver:[
                {desc:'Z',imgPath:zmOver},
                {desc:'F',imgPath:fmOver},
                {desc:'T',imgPath:tmOver}
            ],
            showContract: false,
            contractFileInfo:[],
            imageZInfoObj:{},
            imageFInfoObj:{},
            isAnalyzeZ:true,//是否解析证件照
            isAnalyzeF:true,//是否解析证件照

            popuTime:'',
            loadingText:'加载中,请稍等...',
            
            SwipeImage:['https://img.yzcdn.cn/vant/apple-1.jpg','https://img.yzcdn.cn/vant/apple-2.jpg'],
            //视频变量
            showVerifyCodeModal: false,
            verifyCode: '',
            nextDisabled: false,
            showLoading: false,
            showResult: false,
            videoResultDetail: null,
            videoFail: false,
            videoFailText: {},
            showPopup: false,
            showPopupLable:'',
            authLink:'',
            pZitems: [
                {
                    number: 1,
                    text: '上传有效身份证正面,保证其清晰度',
                    border: 1
                }, 
                {
                    number: 2,
                    text: '正面头像需清晰,否则审核可能不通过',
                    border: 1
                },{
                    number: 3,
                    text: '证件与卡板须在同一个视野范围内',
                    border: 1
                }
            ],
            pFitems: [
                {
                    number: 1,
                    text: '上传有效身份证反面,保证其清晰度',
                    border: 1
                }, {
                    number: 2,
                    text: '证件与卡板须在同一个视野范围内',
                    border: 1
                }
            ],
            items: [
                {
                    number: 1,
                    text: '牢记验证码，点击开始录制',
                    border: 1
                }, {
                    number: 2,
                    text: '开启前置摄像头，用普通话朗读数字',
                    border: 1
                }, {
                    number: 3,
                    text: '录制2-5秒,视频大小为10M以内',
                    border: 1
                },{
                    number: 4,
                    text: '完成录制，等待验证结果',
                    border: 1
                }, {
                    number: 5,
                    text: '每个用户最多只有5次机会可用',
                    border: 0
                }
            ]
        }
    },
    watch:{
        picNameZ(val) {
            this.userInfo.picNameZ = val.slice(this.readImagePath.length);
        },
        picNameF(val) {
            this.userInfo.picNameF = val.slice(this.readImagePath.length);
        },
        imageZInfoObj(val){
            if(val !=''){
                this.userInfo.psptId = val.IDCard;
                this.userInfo.custName = val.name;
                this.userInfo.sex = val.sex;
                this.userInfo.nation = val.nation;
                this.userInfo.birthday = val.birthday;
                this.userInfo.psptLocation =val.address;
            }
        },
        imageFInfoObj(val){
            if(val !=''){
                this.userInfo.penOrg = val.penOrg;
                this.userInfo.penStartTime = val.penStartTime;
                this.userInfo.penEndTime =val.penEndTime;
            }
        }
    },
    created(){
        if(!this.isWeiXin()){
            this.$toast({
                message: "请在微信中打开该链接",
                icon: 'fail'
            });
            this.showView = false;
            return;
        }
        //清楚历史缓存
        sessionStorage.clear();
        this.search.cl = this.$route.params.cl;
        //TODO 校验
        if(this.search.cl == null || this.search.cl == ''){
            return;
        }
    },
    methods: {
        isWeiXin,
        formatTime,
        dataURLtoBlob,
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        setCurrentStep(currentStep){
            this.currentStep = currentStep;
        },
        showContractFile(){
            //显示协议信息
            this.showContract = true;
            this.userInfo.readContract = true;
        },
        showContractClick(){
            //隐藏协议
            this.showContract = false;
            this.userInfo.readContract = true;

        },
        packageChoiceClick(index){
            this.packageChoiceDetail = this.packageList[index];
        },
        //查询套餐包
        queryPackageList(){
            //提交数据
                
            if(this.search.phonenum == ''){
                this.$toast({
                    message: '手机号不能为空',
                    icon: 'fail'
                });
                return;
            }

            if(this.search.phonenum.length != 11){
                this.$toast({
                    message: '输入的手机号不合法',
                    icon: 'fail'
                });
                return;
            }

            if(this.search.iccid == ''){
                this.$toast({
                    message: 'ICCID不能为空',
                    icon: 'fail'
                });
                return;
            }

            if(this.search.iccid.length != 19){
                this.$toast({
                    message: 'ICCID输入不合法',
                    icon: 'fail'
                });
                return;
            }
            // for(var i =0 ;i  < 3;i++){
            //     this.packageList.push({pCode:'code'+i,pName:"name"+i,pDesc:'desc'+i,pAmount:100+i})
            // }
            // this.packageChoiceDetail = this.packageList[0];
            // this.setCurrentStep(2);

            var formdata={
                service : "user.hj5gCheckP",
                phonenum:this.search.phonenum,
                iccid:this.search.iccid,
                cl:this.search.cl,
            }

        
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.packageList = res.packages;
                this.userInfo.phonenum = res.phonenum;
                this.userInfo.iccid = res.iccid;
                this.userInfo.orderCode = res.oCode;
                this.setCurrentStep(2);
                if(this.packageList != null && this.packageList.length > 0){
                    this.packageChoiceDetail = this.packageList[0];
                }
            },(res)=>{
                this.$toast({
                    message: res.errorMsg,
                    icon: 'fail'
                });
            });
        },
        //用户信息填写页面
        goUserInfo(){
            if(this.packageChoiceDetail == null){
                this.$toast({
                    message: '请选择需要的套餐包',
                    icon: 'fail'
                });
                return;
            }
            this.setCurrentStep(3);
        },
        //活体验证页面
        goVideo(){
            if(this.checkInput()){
                this.setCurrentStep(4);
            }
        },
        //开始认证,获取验证码
        startVideo(){
            this.showVerifyCodeModal = true;
            this.setCurrentStep(5);
        },
        //
        checkInput(){
            if(this.userInfo.contractPhone == null || this.userInfo.contractPhone.length != 11){
                this.$toast({
                    message: '请输入联系号码',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.custName == ''){
                this.$toast({
                    message: '姓名不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.psptId == ''){
                this.$toast({
                    message: '证件号不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.psptId.length < 18){
                this.$toast({
                    message: '证件号格式错误',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.psptLocation == ''){
                this.$toast({
                    message: '证件地址不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.sex == ''){
                this.$toast({
                    message: '所属性别不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.nation == ''){
                this.$toast({
                    message: '所属民族不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.penOrg == ''){
                this.$toast({
                    message: '证件发放机构不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.penStartTime == ''){
                this.$toast({
                    message: '证件发放时间不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.penEndTime == ''){
                this.$toast({
                    message: '证件到期时间不能为空',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.picNameZ == null || this.userInfo.picNameZ == ''){
                this.$toast({
                    message: '请上传证件照正面',
                    icon: 'fail'
                });
                return false;
            }
            if(this.userInfo.picNameF == null || this.userInfo.picNameF == '' ){
                this.$toast({
                    message: '请上传证件照反面',
                    icon: 'fail'
                });
                return false;
            }
            if(this.packageChoiceDetail == null ){
                this.$toast({
                    message: '请选择需要的套餐包',
                    icon: 'fail'
                });
                return false;
            }
            if(!this.userInfo.readContract){
                this.$toast({
                    message: '请先阅读《民生通信入网协议》',
                    icon: 'fail'
                });
                return false;
            }
            return true;
        },
        //取消活体认证
        onDialogCancel() {
            this.nextDisabled = false;
            this.showVerifyCodeModal = false;
            this.setCurrentStep(4);
        },
        //重新获取
        onDialogAgain() {
            this.nextDisabled = false;
            this.showResult = false;
            this.showVerifyCodeModal = true;
        },
        //显示结果
        onDialogVideoResult(event, sessionId) {
            // 显示loding图
            const files = event.target.files;
            this.loadLabel = '验证中,有点久哦,请勿退出,耐心等待结果...';
            this.showLoading = true;

            if (files && files.length > 0) {
                let file = files[0];
                if (file.size > 10 * 1024 * 1024) {
                    this.showLoading = false;
                    this.videoFail = true;
                    this.videoFailText = {
                        title: '视频上传失败',
                        detail: '您录制的视频时间过大,请重新录制'
                    };
                    return;
                }

                let reader = new FileReader();
                reader.readAsDataURL(file);
                var _this = this;
                reader.addEventListener('loadend', function () {
                    
                    let formdata = {
                        type: 'faceliveness_verify',
                        apiType: 'faceliveness',
                        session_id: sessionId,
                        video_base64: reader.result.split(',')[1],
                        service: 'user.lineBodyCheck',
                        orderCode:_this.userInfo.orderCode,
                        serialNumber:_this.userInfo.phonenum,
                        simcheck:_this.userInfo.simcheck
                    };

                    _this.$api.post("/mstx/prLong/gateway.do", formdata, (res) => {
                        _this.showLoading = false;
                        _this.showResult = true;
                        _this.videoResultDetail = JSON.parse(res);
                        if(_this.videoResultDetail.err_no === 0){
                            _this.userInfo.picNameT = _this.videoResultDetail.result.pic_list[0].pic;
                        }
                        // 关闭弹窗
                        _this.showVerifyCodeModal = false;
                    },(res)=>{
                        // todo 异常处理
                        _this.showLoading = false;
                        _this.videoFail = true;
                        _this.videoFailText = {
                            title: '认证失败',
                            detail: res.errorMsg
                        };
                    });
                });
            }
        },
        checkPayMoney(){
            if(this.packageChoiceDetail == null){
                this.$toast({
                    message: '请选择需要的套餐包',
                    icon: 'fail'
                });
                return;
            }

            var formdata={
                service : "user.countOpenPrice",
                phonenum : this.userInfo.phonenum,
                pcode : this.packageChoiceDetail.pCode,
            }
            this.showPopupLoading = true;
            this.loadingText = "校验支付信息...";
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.showPopupLoading = false;
                //提交数据
                if(res.needpay){
                    //显示需要支付提示页面
                    this.showPayInfoView = true;
                    this.needPayInfo.phonenum = res.phonenum;
                    this.needPayInfo.backMoney = res.backMoney +" 元";
                    this.needPayInfo.payMoney = res.payMoney +" 元";
                    this.needPayInfo.rechareMoney = res.rechareMoney +" 元";
                    this.needPayInfo.backMonth = res.backMonth;
                    this.needPayInfo.pName = this.packageChoiceDetail.pName;
                }else{
                    //
                    this.goUserInfo();
                }
            },(res)=>{
                this.showPopupLoading = false;
                this.$toast.fail(res.errorMsg);
            });

        },
        submitData(){
            
            if(!this.checkInput()){
                return;
            }

            if(this.userInfo.picNameT == null || this.userInfo.picNameT == ''){
                this.$toast({
                    message: '请进行人体验证',
                    icon: 'fail'
                });
                return;
            }

            var formdata={
                service : "user.hj5gNCommit",
                phonenum : this.userInfo.phonenum,
                iccid : this.userInfo.iccid,
                cl:this.search.cl,
                pcode : this.packageChoiceDetail.pCode,
                name : this.userInfo.custName,
                psptId : this.userInfo.psptId,
                address : this.userInfo.psptLocation,
                gener : this.userInfo.sex,
                nation : this.userInfo.nation,
                birthday : this.userInfo.birthday,
                issuingauth : this.userInfo.penOrg,
                validdate : this.userInfo.penStartTime,
                expdate : this.userInfo.penEndTime,
                contactPhone : this.userInfo.contractPhone,
                imageZ : this.userInfo.picNameZ,
                imageF : this.userInfo.picNameF,
                imageV : this.userInfo.picNameT
            }

            this.$dialog.confirm({
                message: '确认提交订单?'
            }).then(() => {
                this.showPopupLoading = true;
                this.loadingText = "订单提交中,请稍等...";
                this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                    //提交数据
                    this.showPopupLoading = false;
                    if(res.needpay == 1){
                        sessionStorage.setItem(setAesString("orderInfo"),setAesString(JSON.stringify(res)))
                        this.$router.push({path:'/ctcNeedPayInfo'});
                    }else{
                        Dialog.alert({
                            message: '您的开户订单提交成功,请耐心等待结果!'
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                },(res)=>{
                    this.showPopupLoading = false;
                    this.$toast.fail(res.errorMsg);
                    this.showResult = true;
                });
            }).catch(() => {
                this.showResult = true;
            });

            
        },
    }
}
</script>

<style lang="less">
@color-blue: #0073eb;

#app{
    background-color: rgb(255, 255, 255) !important;
}
body{
    background-color: rgb(255, 255, 255) !important;
}

.van-search__content{
    border: 1px solid #dddddd;
}

.index {
    padding-bottom: 0px !important;
    &-orderOption{
        &-content{
        margin: 10px;
        display:flex;
        font-size: 14px;
        &-title{
            float:left;
            margin:0px 5px;
            color: rgb(119, 118, 118);
        }
        }
    
  }
 

    &-swipe {
        margin-top: 47px;
        img {
        width: 100%;
        display: block;
        //  height: 200px;
        }
    }

    &-title {
        font-size: 16px;
    }

    &-price {
        color: #f44;
    }

    &-express {
        color: #999;
        font-size: 12px;
        padding: 5px 15px;
    }

    &-cell-group {
        margin: 15px 0;

        .van-cell__value {
        color: #999;
        }
    }

    &-tag {
        margin-left: 5px;
    }
}

.iconLabel{
  font-size: 12px;
  color: #999;
  margin: 5px 0px;
}

.sketch3 {
    background: rgba(225, 225, 225, .35);
    // padding: .8333rem 1.666rem 1.2rem;
    padding: .0333rem 1.666rem 0.2rem;

    &-img{
        text-align:center;
        img{
            width: 7.916rem;//14.916rem;
            height: 14.583rem;//21.583rem;
            margin: 0 auto;
            // background: url(../../assets/sketch.png) 0 0 no-repeat;
            background-size: 100% auto;
        }
    } 

    &-text {
        font-size: 14px;
        color: #999;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
    }
}

.prompt {
    box-shadow: 0 -0.4rem 0.2rem 0 #e8e8e8;
    padding-bottom: 0.833rem;
    &-box {
        padding: 1.166rem 0 2rem;//2.166rem 0;
        text-align: left;
        padding-left: 10%;
        &-text {
            margin: 0 auto 2.666rem;
            height: .1rem;//1.334rem;
            width: 100%;

            &:last-child {
                margin-bottom: 0;
            }

            &-number {
                border-radius: 20rem;
                border: 0.07rem solid @color-blue;
                text-align: center;
                color: @color-blue;
                display: inline-block;
                width: 1.334rem;
                height: 1.333rem;
                line-height: 1.333rem;
                box-sizing: border-box;
                font-size: 0.7rem;//1rem;
                margin-right: .833rem;
                letter-spacing: 0;
                vertical-align: top;
            }

            &-content {
                color: #333;
                letter-spacing: 0;
                white-space: nowrap;
                display: inline-block;
                font-size: 1rem;//1.333rem;
            }

            &-border {
                height: 1.9rem;
                margin: .417rem 0 .417rem 0.59rem;
                width: 0;
                //  border-left: 0.07rem dotted @color-blue;
                display: block;
            }
        }
    }

    &-next {
        margin: 15px auto;
        height: 45px;
        line-height: 45px;
        text-align: center;
        background: @color-blue;
        border-radius: 4px;
        color: #fff;
        display: block;
        width: 90%;
        font-size: 16px;
        outline: none;
        border: none;
        &-disabled {
            background-color: #ccc;
        }
    }
}



.needPayInfo{
    height: 100%;
    padding: 10px;
    border-radius: 50px;
    margin-top: 5px !important;
    &-data{
        margin-top: 50px;
        background-color:#ffffff;
        padding: 20px;
        margin-bottom: 10px;
    }

    &-warning{
        color:red;
        font-size:11px;
        text-align:left !important;
        margin: 10px 10px;
        &-titel{
            text-align:left !important; 
        }
        &-text{
            text-align:center;
        }
    }
}

</style>
